import StatusRenderer from './StatusRenderer';

export default StatusRenderer;
